import ValidationFeedback from "../displayComponents/validationFeedback";

/** 
 * @param {string} textInputId [Required] Unique id for the input
 * 
 * @param {string} textInputLabel
 * @param {string} textInputType standard html input types, "email", "number", etc
 * @param {string} textInputName name attribute for input field
 * @param {string} textInputPlaceholder
 * @param {string} textInputAriaLabel [Required] Aria label for the input 
 * @param {bool} textInputIsRequired
 * @param {bool} needValidation if set to true - handleChange function will get input element as property 
 *                              if set to false or undefined - handleChange function will get input value as property
 * @param {bool} autoCompleteIsOn if set to true - autocomplete is on
 * 
 * @param {string} pattern input regex validation
 * @param {string} validMessage message that can be shown if input pass validation
 * @param {string} invalidMessage message that can be shown if input does not pass validation
 * 
 * @param {string} textInputContent
 * @param {function} handleChange
*/
function TextInput(props){
    if(props.textInputId === undefined){
        return null;
    }

    if(props.textInputAriaLabel === undefined){
        return null;
    }

    let inputClassName = props.needValidation ? "needValidation" : "";

    return(
        <div className="textInput">
            <label htmlFor={props.textInputId} className="book-meeting__sublabel">
                {props.textInputLabel}{props.textInputIsRequired ? "(påkrevd)" : ""}
            </label>
            <input 
                id={props.textInputId} 
                className={inputClassName} 

                type={props.textInputType}
                name={props.textInputName}
                placeholder={props.textInputPlaceholder}
                
                value={props.textInputContent}
                onChange={e => {
                    props.handleChange(e.target.value);
                }}
                
                aria-label={props.textInputAriaLabel}

                required={props.textInputIsRequired}
                pattern={props.pattern !== undefined ? props.pattern : null}

                autoComplete={props.autoCompleteIsOn === true ? "on" : "off"}

            />

            <ValidationFeedback
                invalidMessage={props.invalidMessage}
                validMessage={props.validMessage}
                textInputIsValid={props.textInputIsValid}
            />
        </div>
    )
}
export default TextInput;